/* eslint-disable react/require-default-props */
import React from 'react';
import { Upload } from 'antd';
import { InboxOutlined } from '@ant-design/icons';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';

import FileIcon from '../icons/files/FileIcon';
import { safeExtractFromObject } from '../../helpers/helpers';

import colors from '../../constants/Colors';

const { Dragger } = Upload;

function OntraccrFileDragger({
  showText = true,
  showIcon = true,
  useDragger = true,
  Icon = InboxOutlined,
  ...props
}) {
  const settings = useSelector((state) => safeExtractFromObject(state, 'settings.company.settings'));
  const hasRedesign = !!settings?.uxRedesignPt1;

  const draggerClass = hasRedesign ? 'ant-upload-redesign' : 'ant-upload-original';
  const textClass = hasRedesign ? 'ant-upload-text-redesign' : 'ant-upload-text';
  const redesignIconStyle = { marginBottom: showText ? 5 : 0 };
  const iconStyle = hasRedesign ? redesignIconStyle : {};
  const MainComponent = useDragger ? Dragger : Upload;

  if (!showIcon && !showText) {
    /*
      For some reason passing showIcon={false} and showText={false} to the component
      below causes the Upload view to shift to right
      when the listType='picture-card' and user uploads a file

      Doesn't happen if we pass no children at all
    */
    return (
      <MainComponent
        className={draggerClass}
        // eslint-disable-next-line react/jsx-props-no-spreading
        {...props}
      />
    );
  }
  return (
    <MainComponent
      className={draggerClass}
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...props}
    >
      {showIcon && (
        <div style={iconStyle}>
          {
            hasRedesign
              ? <FileIcon />
              : <Icon style={{ color: colors.ONTRACCR_RED, fontSize: 30 }} />
          }
        </div>
      )}
      {showText && <p className={textClass}>Drag your file or click to browse</p>}
    </MainComponent>
  );
}

OntraccrFileDragger.propTypes = {
  showText: PropTypes.bool,
  showIcon: PropTypes.bool,
  useDragger: PropTypes.bool,
  Icon: PropTypes.node,
};

export default OntraccrFileDragger;
